<template>
  <div class="form-group">
    <label :for="label">{{ label }}</label>
    <div class="input-group">
      <span class="input-group-addon" style="min-width: 45px">
        <span class="ar-icon ar-icon-sm" :class="icon"></span>
      </span>
      <select
        :id="label"
        class="form-control"
        :disabled="disabled"
        :value="value"
        @input="$emit('input', $event.target.value)"
      >
        <option v-for="(source, index) in sources" :key="source.deviceId" :value="source.deviceId">
          {{ source.label || `${defaultNamePrefix} ${index}` }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: "CallSettingsDevicesSelect",
  props: {
    label: {
      required: true,
      type: String
    },
    sources: {
      required: true,
      type: Array
    },
    disabled: {
      required: false,
      default: false,
      type: Boolean
    },
    defaultNamePrefix: {
      required: false,
      default: "Source",
      type: String
    },
    value: {
      required: true
    },
    icon: {
      required: true,
      type: String
    }
  }
};
</script>
